module.exports = __webpack_public_path__ + "static/media/contact-second.f50f794e.jpg";